<template>
    <Modal @opened="initPayPal" :width="320" hide-footer :dismissible="!!errors.length">
        <div v-if="errors.length" class="error-messages alert alert-danger" role="alert" ref="errorMessages">
            <ul class="list-unstyled mb-0">
                <li v-for="(error, index) in errors" :key="'error' + index" v-html="error"></li>
            </ul>
        </div>

        <div id="paypal-button-container"></div>
    </Modal>
</template>

<script>
import Modal from '@/components/Modal';
import { loadScript } from '@paypal/paypal-js';

export default {
    name: 'PayPalModal',
    components: { Modal },
    data() {
        return {
            errors: []
        };
    },

    props: {
        order: {
            type: Object,
            required: true
        }
    },

    computed: {},

    methods: {
        async initPayPal() {
            try {
                this.errors = [];

                const paypal = await loadScript({
                    'client-id': this.$config.paypalId,
                    currency: 'EUR',
                    locale: 'de_DE',
                    'disable-funding': 'sofort,giropay,card'
                });

                paypal
                    .Buttons({
                        // Call your server to set up the transaction
                        createOrder: async function (data, actions) {
                            this.errors = [];
                            try {
                                const { data: orderData } = await this.$axios.post(
                                    `/payment/paypal/create-order/${this.order.orderId}`
                                );
                                return orderData.id;
                            } catch (e) {
                                this.errors = Array.isArray(e) ? e.map(e => e.text || e.message) : [e.message];
                            }
                        }.bind(this),

                        // Call your server to finalize the transaction
                        onApprove: async function (data, actions) {
                            this.errors = [];
                            try {
                                const { data: orderData } = await this.$axios.post(
                                    `/payment/paypal/capture-order/${this.order.orderId}`
                                );

                                if (orderData.redirectUrl) {
                                    location.href = orderData.redirectUrl;
                                } else {
                                    const { orderId, orderHash } = orderData;
                                    this.$router.push({
                                        name: 'success',
                                        params: {
                                            orderId,
                                            orderHash
                                        }
                                    });
                                }
                            } catch (e) {
                                this.errors = Array.isArray(e) ? e.map(e => e.text || e.message) : [e.message];
                            }
                        }.bind(this)
                    })
                    .render('#paypal-button-container');
            } catch (err) {
                this.errors = ['Fehler beim Laden des PayPal JS SDK-Skripts'];
                console.error('failed to load the PayPal JS SDK script', err);
            }
        }
    }
};
</script>

<style scoped lang="scss">
#paypal-button-container {
    min-height: 260px;
}
</style>
